// DEPENDENCIES ---------------------------------------------------------------- //

// import React from 'react';

import { useTimeline } from '@components/Timeline/Timeline/TimelineProvider';

// TYPES ---------------------------------------------------------------- //

export interface TimelineIndexRowProps {
  dataItem: any;
  index: number;
  isLastItem?: boolean;
}

// COMPONENT ---------------------------------------------------------------- //

const TimelineIndexRow = ({ dataItem, index, isLastItem = false }: TimelineIndexRowProps) => {
  const {
    componentIndexRow: ComponentIndexRow,
    componentIndexRowProps,
    rowSize,
    timezoneOverride,
    zoom,
  } = useTimeline();

  if (ComponentIndexRow) {
    // Extract functions from props that need dataItem
    const { isSelected, onClick, ...otherProps } = componentIndexRowProps || {};

    return (
      <ComponentIndexRow
        {...otherProps}
        dataItem={dataItem}
        index={index}
        isLastItem={isLastItem}
        rowSize={rowSize}
        timezoneOverride={timezoneOverride}
        zoom={zoom}
        isSelected={typeof isSelected === 'function' ? isSelected(dataItem) : isSelected}
        onClick={typeof onClick === 'function' ? () => onClick(dataItem) : onClick}
      />
    );
  }
  return null;
};

// -------------------------------- EXPORT -------------------------------- //

export default TimelineIndexRow;
